export const environment = {
  production: false,
  environmentName: 'staging',
  backendUrl: '',
  apiUrl: '/api',
  wordpressUrl: 'https://test.viaaqua.com',
  wordpressSsoEntryUrl: 'https://test.viaaqua.com/sso-redirect',
};
